import {
  makeAddressArraySync,
  makeAddressSync,
  ProtocolConfig,
} from "@silo/types";
import { satisfies } from "effect/Function";
import { TOKEN_ADDRESS } from "../token-address";
import { MARKET_ADDRESS } from "../market-address";

export const mainnetLegacy = satisfies<ProtocolConfig>()({
  firstBridgeSymbol: "ETH",
  secondBridgeSymbol: "XAI",
  marketWhitelist: new Set([
    MARKET_ADDRESS.mainnetLegacy.WBTC,
    MARKET_ADDRESS.mainnetLegacy.wstETH,
    MARKET_ADDRESS.mainnetLegacy.USDC,
    MARKET_ADDRESS.mainnetLegacy.cbETH,
    MARKET_ADDRESS.mainnetLegacy.AURA,
    MARKET_ADDRESS.mainnetLegacy.USDT,
    MARKET_ADDRESS.mainnetLegacy.weETH,
    MARKET_ADDRESS.mainnetLegacy.ezETH,
  ]),
  pinnedMarkets: [
    MARKET_ADDRESS.mainnetLegacy.weETH,
    MARKET_ADDRESS.mainnetLegacy.ezETH,
  ],
  markets: {
    [MARKET_ADDRESS.mainnetLegacy.gOHM]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.weETH]: {
      points: {
        base: {
          collateral: [
            { _tag: "eigenLayer" },
            { _tag: "etherFi", label: "2x EtherFi" },
          ],
        },
        firstBridge: {
          collateral: [{ _tag: "etherFi", label: "1x EtherFi" }],
        },
      },
    },
    [MARKET_ADDRESS.mainnetLegacy.ezETH]: {
      points: {
        base: {
          collateral: [
            { _tag: "eigenLayer" },
            { _tag: "renzo", label: "2x Renzo" },
          ],
        },
        firstBridge: {
          collateral: [{ _tag: "renzo", label: "1x Renzo" }],
        },
      },
    },
    [MARKET_ADDRESS.mainnetLegacy.rsETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.PTweETH]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.PTrswETH]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.PTrsETH]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.ETH_cbETH]: {
      curveLpTokenAddress: makeAddressSync(
        "0x5b6c539b224014a09b3388e51caaa8e354c959c8"
      ),
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetLegacy.ETH_stETH]: {
      curveLpTokenAddress: makeAddressSync(
        "0x06325440d014e39736583c165c2963ba99faf14e"
      ),
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetLegacy.FRAX_USDC]: {
      curveLpTokenAddress: makeAddressSync(
        "0x3175df0976dfa876431c2e9ee6bc45b65d3473cc"
      ),
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetLegacy.LUSD_3CRV]: {
      curveLpTokenAddress: makeAddressSync(
        "0xed279fdd11ca84beef15af5d39bb4d4bee23f0ca"
      ),
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetLegacy.stETH_NG]: {
      curveLpTokenAddress: makeAddressSync(
        "0x21E27a5E5513D6e65C4f830167390997aA84843a"
      ),
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.PTezETH]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.PTezETH_DEC2024]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.RPL]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.QNT]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.LUSD]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.BAL]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.rETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.FXS]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.DAI]: {
      isDebtAprFixed: {
        secondBridge: true,
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.XAI]: {
      isDebtAprFixed: {
        base: true,
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.LQTY]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.DYDX]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.FARM]: {
      labelAsDeprecated: true,
      suppressTvl: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.OHM]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.CRV]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.ONEINCH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.XDEFI]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.MKR]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.YFI]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.PEPE]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.ETHx]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.FRAX]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.APE]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLegacy.CVX]: {
      labelAsDeprecated: true,
    },
  },
  nativeRewards: {
    siloIncentivesControllerAddress: makeAddressSync(
      "0x6c1603aB6CecF89DD60C24530DdE23F97DA3C229"
    ),
    tokenAddress: TOKEN_ADDRESS.ethereum.SILO,
    symbol: "SILO",
    decimals: 18,
    historicalShareTokens: {
      [TOKEN_ADDRESS.ethereum.SILO]: makeAddressArraySync([
        // scbETH
        "0x2420930aDb6946E4bf5F4685539eC6f7929DaE5A",
        // sWETH-cbETH
        "0x315c9c216BBA84017C2204b248F29023c04C4e07",
        // dXAI-cbETH
        "0xF3f92B1b2A4Af2b238b78AdbCEFdd1Cb7cAE0D36",
        // swstETH
        "0xeCC96f56Ea198991b85A10F2845D04F96Ec924eA",
        // sWETH-wstETH
        "0x5ed68Fcfa0a531bBfE1078cC65bd50015BBC4bdA",
        // dXAI-wstETH
        "0xbc35924Bf9fB053bd77E6f2F5227bDedB0e11CBB",
        // srETH
        "0x7b1F6fb13d3c8f76Eca4fcc1da4A4d4317A33f79",
        // sWETH-rETH
        "0x9c8168C88d90Fd777041053cCB56D809eDEf4d74",
        // sXAI-rETH
        "0x8CCD889bb3a0252b803B6B6eaA0404c40CF8Cca7",
        // dOHM
        "0x85A44Ff42F6B89125a541F64c77840977b0097E2",
        // sOHM
        "0x907136B74abA7D5978341eBA903544134A66B065",
        // sWETH-stkcvxsteCRV-silo
        "0xF98B72b02969001b0093349Ec39ce4F2d5C5592c",
        // sweETH
        "0xFBc74f4CFf1CF833997DD4d0A57a75687DadF7d6",
        // sWETH-weETH
        "0x9D4B3926031a9EC6f5B64274ffB3e8eD3fA296D8",
        // sETHx
        "0xb88d68Fb1fDc66008DDE8A4661718F91c2C61dc6",
        // sWETH-ETHx
        "0xa134C033b2BF185414169d569B367fBDC82E2aF8",
        // sWETH-PT-ezETH
        "0xC1811E05AE408d1D42c8891A25134c95C58fF003",
        // spPT-ezETH
        "0x93B35CF3707AD7d8794615A3F4C166647ec128B1",
        // sWETH-ezETH
        "0x863a5F62d6e871d94f46e3F7ced3350899402B52",
        // sWETH-rsETH
        "0xc1f7682280387Ff216F7Ea9bc58c374A61e5ba1A",
        // sWETH-PTweETH
        "0x00BabBd12365B55B692f124aEFD4034F5B53e4AB",
        //sWETH-PTezETH_DEC2024
        "0x9C2eB9Fc7dBD1a941AaE597764c301555D1DBc01",
      ]),
    },
  },
} as const);
